import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Alert, Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import Logo from "../assets/images/logo.png";
import { DesktopContainer } from "../layouts";
import { api } from "../utils";

export default function ForgotPassword(props) {
   const backToSignInPath = "/login";
   const submitURL = "Public/ForgotPassword";
   const location = useLocation();
   const navigate = useNavigate();
   const { state } = location;
   const [authData, setAuthData] = useState({ username: state && state.email ? state.email : "" });
   const [message, setMessage] = useState(null);

   function onChange(fieldName, fieldValue) {
      let newData = Object.assign({}, authData);
      newData[fieldName] = fieldValue;
      setAuthData(newData);
   }

   function onSubmit() {
      const warnings = validate();
      if (warnings.length) {
         setMessage({
            text: warnings.join(" "),
            flavor: "alert-danger",
         });
         return;
      } else {
         setMessage(null);
      }
      api
         .post(submitURL, {
            username: authData.username,
         })
         .then((response) => {
            if (api.isRateLimited(response)) return;   // already toasted by the api interceptor
            if (response.data.success) {
               setMessage({
                  flavor: "alert-success",
                  text: "If we have a user with that address, we've just sent a reset link!",
               });
               setTimeout(() => {
                  navigate("/login")
               }, 5000);
            } else {
               setMessage({ flavor: "alert-danger", text: response?.data?.message });
            }
         })
         .catch(api.catchHandler);
   }

   function validate() {
      let warnings = [];
      if (!authData.username) {
         warnings.push("Username is required");
      }
      return warnings;
   }

   return (
      <DesktopContainer fluid>
         <Row className="pt-5 justify-content-center position-static">
            <Col xs={6}>
               <Row className="pt-5 justify-content-center">
                  <img id="Logo" src={Logo} alt="logo" style={{ width: "150px" }} />
               </Row>
               <Row className="mt-3">
                  <Col xs={12}>
                     <Form>
                        <FormGroup>
                           <Label>Enter your username and we will send you a reset link.</Label>
                           <Input
                              type="text"
                              value={authData.username}
                              onChange={(e) => onChange("username", e.target.value)}
                              placeholder="Username"
                              maxLength="250"
                           />
                        </FormGroup>
                        <FormGroup>
                           <Button
                              className="projectPrimary float-start"
                              onClick={onSubmit}
                              children="Reset Password"
                           />
                           <Link
                              to={backToSignInPath}
                              className="float-end"
                              children="Wait, I already have an account - take me to log in!"
                           />
                        </FormGroup>
                     </Form>
                  </Col>
               </Row>
               {message ? (
                  <Row className="mt-3">
                     <Col>
                        <Alert className={message.flavor}>{message.text}</Alert>
                     </Col>
                  </Row>
               ) : null}
            </Col>
         </Row>
      </DesktopContainer>
   );
}
